import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const CustomersFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.customers.totalUsersCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
